import { trans } from '@spotahome/soyuz/client';
import { Mediator } from '@spotahome/soyuz-mediator';
import { CHANNELS } from '@spotahome/ui-library';
import ListingContent from '@spotahome/marketplace-common/src/components/ListingContent';

const openLandlordPoliciesSimplifiedModal = ({
  landlordPolicies,
  fullscreenOnMobile = false
} = {}) => {
  Mediator.publish(CHANNELS.OPEN_INFORMATION_MODAL, {
    title: trans('property_show.title.landlord_policies'),
    body: <ListingContent content={landlordPolicies} />,
    fullscreenOnMobile
  });
};

export default openLandlordPoliciesSimplifiedModal;
